import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { EDIT_HEADER_TITLES } from './constants';

export default function Header({ title, className, id }) {
  return (
    <div id={id} className={className}>{EDIT_HEADER_TITLES[title] || 'Edit Photo'}</div>
  );
}

Header.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
};

Header.defaultProps = {
  title: null,
  className: '',
};
